import {ContractorCategoryDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'CREATE_CONTRACTOR_CATEGORY';

export async function createContractorCategory(userData: any, payload: Record<string, unknown>) {
    try {
        const result = await ContractorCategoryDao.createContractorCategory(userData, payload);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création de la catégorie sous/co-traitant',
            error: error
        });
    }
}
